// extracted by mini-css-extract-plugin
export default {"icon":"login-registartion-imgs_icon__GuARv","iconRed":"login-registartion-imgs_iconRed__2iVOf"};